import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getContactAddress: function ({
    limit = 9999,
    page = 1,
    client,
    leaseExpDate,
    lang,
    sort,
    residentialAddress,
    expireStatus,
    search
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (client) query.push(`client[]=${client}`)
    if (expireStatus) query.push(`expireStatus[]=${expireStatus}`)
    if (leaseExpDate) query.push(`leaseExpDate=${leaseExpDate}`)
    if (sort) query.push(`sort[]=${sort}`)
    if (lang) query.push(lang)
    if (residentialAddress) query.push(`residentialAddress[]=${residentialAddress}`)
    if (search) query.push(`search=${search}`)
    const name = search ? 'clientresidentialaddresses?' : 'clientresidentialaddresses?'
    return instCred.get(name + query.join('&'))
  },
  getContactAddressById: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('clientresidentialaddresses/' + id)
  },
  createContactAddress: function (address) {
    address.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('clientresidentialaddresses', address)
  },
  updateContactAddress: function (address) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('clientresidentialaddresses/' + address.id, address)
  },
  deleteContactAddress: function (addressId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('clientresidentialaddresses/' + addressId)
  }
}



// WEBPACK FOOTER //
// ./src/api/ContactsAddress/api.js